import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Images } from '../../../@resources/img';
import { useWindowSizeInRem } from '../../../platform/Hook';
import { Flexer } from '../../dashboard/elements/LayoutElements';

const duration = 400;

const up = keyframes`
    0% {
        transform: translateY(0rem);
    }
    100% {
        transform: translateY(-5rem);
    }
`;

const down = keyframes`
    0% {
        transform: translateY(-5rem);
    }
    100% {
        transform: translateY(0rem);
    }
`;

const Vert = styled.div`
    animation: 
        ${up} ${duration / 2}ms cubic-bezier(0,.6,.6,1) 0ms,
        ${down} ${duration / 2}ms cubic-bezier(.6,0,1,.6) ${duration / 2}ms;
`;

const Hori = styled.div<{ leftRight: any }>`
    position: absolute;
    left: 0;
    top: 0;
    animation: ${p => p.leftRight} ${duration}ms linear;
    animation-fill-mode: forwards;
`;

const ImgFrame = styled.div`
    img {
        width: 12rem;
        max-width: initial;
        /* transform: translate(120%) scaleX(-1) rotate(20deg); */
    }
`;

export const ThrowEgg = () => {

    const ws = useWindowSizeInRem();
    const leftRight = keyframes`
        0% {
            transform: translateX(-10rem);
        }
        100% {
            transform: translateX(${ws.width}rem);
        }
    `;

    return <Flexer absolute width="100%" height="10rem" background="red" pointerEvents="none">
        <Hori leftRight={leftRight}>
            <Vert>
                <ImgFrame>
                    <img src={Images.Ball} />
                </ImgFrame>
            </Vert>
        </Hori>
    </Flexer>;
};
